<template>
  <div v-if="visibleSnackbar" class="snackbar">
    <span>Você alterou a visualização para outro contrato.</span>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapState } from 'vuex'

export default Vue.extend({
  components: {},
  data() {
    return {}
  },
  mounted() {},
  computed: {
    ...mapState(['visibleSnackbar'])
  },
  watch: {},
  methods: {}
})
</script>

<style lang="scss">
.snackbar {
  width: 100%;
  height: 48px;
  max-width: 400px;
  background-color: $grayscale-base;
  color: $base-white;
  font-size: $font-size-small;
  box-shadow: 0px 4px 8px rgba(96, 97, 112, 0.16);
  border-radius: 4px;
  padding: 0 1rem;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  position: absolute;
  bottom: 24px;
  left: 0;
  right: 0;
  margin: 0 auto;
  z-index: 1;
  animation: moveUpDown 0.2s 1;

  animation-timing-function: ease-in-out;
  -webkit-animation-timing-function: ease-in-out;
}

@keyframes moveUpDown {
  from {
    bottom: 0;
  }
  to {
    bottom: 24px;
  }
}
</style>
